<!-- <div *ngIf="!isAdd" (click)='collapse()' [ngStyle]="{'cursor': !isEditable?'pointer':''}"> -->
<div *ngIf="!isAdd">
    <div class='col-sm-1'>{{courseRegistration.id}}</div>
    <div (click)='collapseRegistrant()' class='col-sm-8' [ngStyle]="{'cursor': !isEditable?'pointer':''}">
        {{user.firstname}} {{user.lastname}} ({{user.id}}, {{user.username}}) <span *ngIf="user.hasParsInfo" class="text-info" style="font-style: italic;"> | Has License/Board info</span>
        <span *ngIf="user.pastDue" class="error" style="font-style: italic;"> | Past Due</span>
    </div>
    <div class='col-sm-1 text-center'>
        {{courseRegistration.status.name}}
    </div>
    <div class="col-sm-1 text-right">
        <app-collapse-button (click)='collapseRegistrant()' *ngIf="!isEditable" [isActive]="true" [ngStyle]="{'cursor': !isEditable?'pointer':''}"></app-collapse-button>
    </div>
    <div class="col-sm-1 text-right">
        <app-delete-button-sm (click)='delete()' *ngIf="!isEditable"></app-delete-button-sm>
    </div>
    <div class="col-sm-12" *ngIf="user.pastDue" style="font-size:0.8em; font-style: italic;">
        This user has a Past Due Fee of ${{user.pastDue.amount|number:'1.2'}} with {{user.pastDue.region}} for "{{user.pastDue.event}}" ({{user.pastDue.eventId}})
    </div>
    <!-- <div><pre>{{courseRegistration | json}}</pre></div> -->
    <div *ngIf="displayRegistrant" class="col-md-12" style="border-style: dashed; border-color: skyblue; border-width: 2px;">
        <app-course-registrant [courseRegistration]="courseRegistration" style="width:100%;"></app-course-registrant>
    </div>
</div>

<div *ngIf='loadingMsg'>
    <div class='text-center col-sm-12' style='padding:1.0em 0'>
        <div>{{loadingMsg}}</div>
    </div>
</div>

<div [ngClass]="{'hide':!display}" class="col-sm-12">

    <app-loading [isLoading]="isLoading" *ngIf="isLoading"></app-loading>

    <div style='padding-bottom:0.5em;' *ngIf='isLoaded' [ngStyle]="{'margin-top': !isAdd ? '2.0em' : '0'}">
        <form [formGroup]="form" (ngSubmit)="save()" novalidate>

            <div class="instructions">
                <div class='pull-right action-menu-sm'>
                    <app-button-status *ngIf="isSaving || isDeleting"></app-button-status>
                    <app-edit-button-sm (click)='edit()' *ngIf="!isEditable"></app-edit-button-sm>
                    <app-delete-button-sm (click)='delete()' *ngIf="!isEditable"></app-delete-button-sm>
                    <app-save-button-sm (click)='save()' *ngIf="isEditable"></app-save-button-sm>
                    <app-cancel-button-sm (click)='cancel()' *ngIf="isEditable"></app-cancel-button-sm>
                </div>
                <div *ngIf="!isAdd">Below are details specific to this Registration.</div>
                <div *ngIf="isAdd">Complete the form below to create a Registration.</div>
            </div>
            
            <div class='text-center error' *ngIf='errorMessage'>
                {{errorMessage}}
            </div>

            <div>
                <label>
                    First Name *
                    <span *ngIf="firstname.invalid && (firstname.dirty || firstname.touched || isSubmitted)" class="error">
                        <span *ngIf="firstname.errors.required">- Required</span>
                        <span *ngIf="firstname.errors.maxlength">- Too long</span>
                    </span>
                </label>
                <div *ngIf="!isEditable">{{ ( user.firstname ) ? user.firstname : "-" }}</div>
                <div *ngIf="isEditable">
                    <input id="firstname" formControlName="firstname" placeholder="Name" required class="form-control" maxlength="300">
                </div>
            </div>

            <div>
                <label>
                    Last Name *
                    <span *ngIf="lastname.invalid && (lastname.dirty || lastname.touched || isSubmitted)" class="error">
                        <span *ngIf="lastname.errors.required">- Required</span>
                        <span *ngIf="lastname.errors.maxlength">- Too long</span>
                    </span>
                </label>
                <div *ngIf="!isEditable">{{ ( user.lastname ) ? user.lastname : "-" }}</div>
                <div *ngIf="isEditable">
                    <input id="lastname" formControlName="lastname" placeholder="Name" required class="form-control"
                        maxlength="300">
                </div>
            </div>

            <div>
                <label>
                    Status *
                    <span *ngIf="status.invalid && (status.dirty || status.touched || isSubmitted)" class="error">
                        <span *ngIf="status.errors.required">- Required</span>
                        <span *ngIf="status.errors.maxlength">- Too long</span>
                    </span>
                </label>
                <div *ngIf="!isEditable">{{ ( courseRegistration.status ) ? courseRegistration.status.name : "-" }}</div>
                <div *ngIf="isEditable">
                    <div *ngIf="isEditable">
                        <ng-select id="status" formControlName="status" [items]="statuses" bindValue="value" bindLabel="name" placeholder="Select Status" [clearable]="false" [searchable]="false"></ng-select>
                    </div>
                </div>
            </div>

        </form>
        <!-- <div><pre>{{courseRegistration|json}}</pre></div> -->
    </div>
</div>